import React, { useEffect } from "react";
import "./New_In_Store.css";
import Store_Product_Card from "./store_product_card/Store_Product_Card";
import { useNavigate } from "react-router-dom";
import Common_Heading_Holder from "../../common-components/common_heading_holder/Common_Heading_Holder";

const New_In_Store = ({ data }) => {
  const navigate = useNavigate();

  const data2 = [
    {
      name: "Beverages",
      img: "/assets/images/products/img1.png",
      discount: 10,
    },
    {
      name: "Noodels and Pasta",
      img: "/assets/images/products/img2.png",
    },
    {
      name: "Beverages",
      img: "/assets/images/products/img3.png",
      discount: 10,
    },
    {
      name: "Coffee & Tea",
      img: "/assets/images/products/img4.png",
      discount: 10,
    },
    {
      name: "Ice Cream and Frozen Desserts",
      img: "/assets/images/products/img5.png",
    },
    {
      name: "Coffee & Tea",
      img: "/assets/images/products/img5.png",
    },
  ];

  console.log("New_In_Store", data);

  return (
    <section className="New_In_Store">
      <Common_Heading_Holder
        headingText={"New in Store"}
        viewShowAllButton
        goto="/all-products"
      />

      <div className="main_content_div">
        <div className="row">
          <div className="col-xxl-5 col-md-4">
            <div className="main_img_div">
              <Store_Product_Card
                img={data?.[0]?.image}
                name={data?.[0]?.name}
                id={data?.[0]?.id}
              />
            </div>
          </div>

          <div className="col-xxl-7 col-md-8">
            <div className="grid_view_div">
              {data?.slice(1, 7)?.map((item) => {
                return (
                  <Store_Product_Card
                    id={item?.id}
                    img={item?.image}
                    name={item?.name}
                    discount={item?.discount}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default New_In_Store;
